import withNavigate from "../../../routes/withNavigate";
import WalletTransactionsContainer from "./WalletTransactionsContainer.jsx";
import WalletTransactionsStore from "./WalletTransactionsStore.js";

export default WalletTransactionsStore(withNavigate(WalletTransactionsContainer));